import { API } from '@redux/services/api';
import { apiRequest } from './common';

export const fetchUserRank = async (options = {}) => {
  return apiRequest({
    url: `${API.BASE_URL}${API.GET_USER_RANK_INFO}`,
    method: 'GET',
    ...options
  });
};
